<template>
  <!--[side]-->
  <div class="side">
    <h1 class="side-logo"><img class="img-fluid" :src="headerLogo" :alt="logoAlt" /></h1>
    <div class="side-body">
      <nav v-if="permission.isGmoOrOffice() && isGmoOrOfficeUrl" class="side-nav">
        <ul class="side-nav-set">
          <li class="side-nav-item">
            <router-link
              :to="{ name: 'EventList' }"
              :class="{ 'side-nav-link': true, 'is-active': isActive('EventList') }"
            >
              <i class="aikon aikon-drawer side-nav-icon"></i>親イベント一覧
            </router-link>
          </li>
          <li v-if="isRouteWithSubdomain" class="side-nav-item">
            <router-link
              :to="{ name: 'EventDashboardParent' }"
              :class="{ 'side-nav-link': true, 'is-active': isActive('EventDashboardParent') }"
            >
              <i class="aikon aikon-squares side-nav-icon"></i>
              {{ parentEventName }}
            </router-link>
          </li>
          <template v-if="isRouteWithSubdomain && !isRouteWithDirectory">
            <li v-for="item in masterOrClientEventParentNav" :key="item.index" class="side-nav-item">
              <router-link
                v-if="checkPolicy(item.policy, item.shopFlag) && checkTypePoint(item.typePoint)"
                :to="{ name: item.routeName }"
                :class="{ 'side-nav-link': true, 'is-active': isActive(item.routeName, item.pattern) }"
              >
                <i :class="`aikon ${item.icon} side-nav-icon`"></i>{{ item.content }}
              </router-link>
            </li>
          </template>
        </ul>
        <template v-if="isRouteWithDirectory">
          <p class="side-nav-title">{{ childEventDetail.name }}</p>
          <ul class="side-nav-set">
            <li v-for="item in masterOrClientEventChildNav" :key="item.index" class="side-nav-item">
              <router-link
                v-if="checkPolicy(item.policy) && checkCurrencyFlag(item.currencyFlag) && checkEventSummary(item.policy) && checkTypePoint(item.typePoint) && checkHistoryFlag(item.historyFlag)"
                :to="{ name: (!hasShopRole && item.routeName === 'EventSummary') ?  'EventSummaryCompany' : item.routeName }"
                :class="{ 'side-nav-link': true, 'is-active': isActive(item.routeName, item.pattern) }"
              >
                <i :class="`aikon ${item.icon} side-nav-icon`"></i>{{ item.content }}
              </router-link>
            </li>
          </ul>
        </template>
      </nav>
      <nav v-else-if="permission.isStoreOrGroup() || isGmoOrOfficeLoginStore" class="side-nav">
        <ul class="side-nav-set">
          <li class="side-nav-item">
            <router-link
              :to="{ name: 'ShopEventDashboardParent' }"
              :class="{ 'side-nav-link': true, 'is-active': isActive('ShopEventDashboardParent') }"
            >
              <i class="aikon aikon-squares side-nav-icon"></i>
              {{ parentEventName }}
            </router-link>
          </li>
          <template v-if="!isRouteWithDirectory">
            <li v-for="item in shopOrGroupEventParentNav" :key="item.index" class="side-nav-item">
              <template
                v-if="checkGroupFlag(item.groupFlag) && checkCustomerFlag(item.customerFlag) &&
                  checkPolicy(item.policy) && checkCpmFlag(item.cpmFlag) && checkTypePoint(item.typePoint)"
                >
                <a v-if="item.href" class="side-nav-link" :href="item.href" target="_blank">
                  <i :class="`aikon ${item.icon} side-nav-icon`"></i>{{ item.content }}
                </a>
                <button v-else-if="item.cpmFlag" class="side-nav-link" @click="handleTabCPM">
                  <i :class="`aikon ${item.icon} side-nav-icon`"></i>{{ item.content }}
                </button>
                <router-link
                  v-else
                  :to="{ name: item.routeName }"
                  :class="{ 'side-nav-link': true, 'is-active': isActive(item.routeName, item.pattern) }"
                >
                  <i :class="`aikon ${item.icon} side-nav-icon`"></i>{{ item.content }}
                </router-link>
              </template>
            </li>
          </template>
        </ul>
        <template v-if="isRouteWithDirectory">
          <p class="side-nav-title">{{ childEventDetail.name }}</p>
          <ul class="side-nav-set">
            <li v-for="item in shopOrGroupEventChildNav" :key="item.index" class="side-nav-item">
              <template v-if="checkPolicy(item.policy) && checkTypePoint(item.typePoint)">
                <a v-if="item.href" class="side-nav-link" :href="item.href" target="_blank">
                  <i :class="`aikon ${item.icon} side-nav-icon`"></i>{{ item.content }}
                </a>
                <router-link
                  v-else
                  :to="{ name: item.routeName }"
                  :class="{ 'side-nav-link': true, 'is-active': isActive(item.routeName, item.pattern) }"
                >
                  <i :class="`aikon ${item.icon} side-nav-icon`"></i>{{ item.content }}
                </router-link>
              </template>
          </li>
          </ul>
        </template>
      </nav>
    </div>
    <nav v-if="permission.isGmoOrOffice() && !isGmoOrOfficeLoginStore" class="side-subMenu">
      <ul class="side-subMenu-set">
        <li v-for="item in masterOrClientMenu" :key="item.index" class="side-subMenu-item">
          <a v-if="item.href" class="side-subMenu-link" :href="item.href" target="_blank">
            <i :class="`aikon ${item.icon} side-subMenu-icon`"></i>{{ item.content }}
          </a>
          <router-link v-else
            :to="{ name: item.routeName }"
            :disabled="checkDisabledIcon(item.pattern)"
            :class="{
              'side-subMenu-link': true,
              'btn-disabled': checkDisabledIcon(item.pattern),
              'is-active': isActive(item.routeName, item.pattern)
            }"
          >
            <i :class="`aikon ${item.icon} side-subMenu-icon`"></i>
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="side-user">
      <div class="side-user-header">
        <p class="side-user-admin" v-if="isGmoOrOfficeLoginStore">
          {{ upperCase(nameAdmin) }}
        </p>
        <p class="side-user-authority">
          {{ upperCase(nameRole) }}
        </p>
        <p class="side-user-name">{{ accountName }}</p>
      </div>
      <div class="side-user-body">
        <button
          v-if="isGmoOrOfficeLoginStore"
          class="btn btn-w100 btn-white side-user-btn"
          :class="{ 'custom-side-btn': isGmoOrOfficeLoginStore }"
          type="button"
          @click="handleRedirect"
        >
          {{ backBtnName }}
        </button>
        <nav class="side-user-nav">
          <router-link
            v-if="!isGmoOrOfficeLoginStore || isGmoOrOfficeLoginStoreUseCpm"
            class="side-user-link"
            :to="{ name: isGmoOrOfficeLoginStoreUseCpm ? 'AccountUserCpm' : 'AccountUser' }"
          >
            アカウント設定
          </router-link>
          <router-link v-if="isCpmMenuShown" class="side-user-link" :to="{ name: 'AccountCompany' }"
            >{{ permission.isOffice() ? '事務局/企業設定' : '企業設定' }}</router-link>
        </nav>
        <button class="btn btn-w100 btn-black side-user-btn" :class="{ 'custom-side-btn': isGmoOrOfficeLoginStore }" type="button" @click="logout">ログアウト</button>
      </div>
    </div>
  </div>
  <!--[/side]-->
</template>


<script setup>
import { computed, ref, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { RoleConstants } from '@/constants/role';
import { StatusConstants } from '@/constants/status';
import { getEncodedRefreshToken } from '@/helpers/http';
import { upperCase } from '@/filters/characters';
import permission from '@/helpers/permission';
import message from '@/helpers/message';

const store = useStore();
const route = useRoute();
const router = useRouter();
const defaultQuestionHref = 'https://gmo-housepay.zendesk.com/hc/ja';

const masterOrClientEventParentNav = ref([
  { routeName: 'EventShop', icon: 'aikon-shop', content: '店舗管理', policy: 'SHOPS', shopFlag: true },
  { routeName: 'EventUser', icon: 'aikon-user', content: '顧客管理', policy: 'CUSTOMERS', pattern: 'EventUser' },
  { routeName: 'EventCoupon', icon: 'aikon-coupon', content: 'クーポン', policy: 'COUPONS' },
  { routeName: 'EventParentPointHistory', icon: 'aikon-point', content: 'ポイント', typePoint: 1, pattern: 'EventParentPoint' },
]);
const logoAlt = ref(process.env.VUE_APP_APP_NAME);
const logoSrc = ref(process.env.VUE_APP_LOGO_IMAGE);
const instance = getCurrentInstance();

const infor = computed(() => store.getters['auth/infor']);
const parentEventDetail = computed(() => store.getters['event/parentEventDetail']);
const childEventDetail = computed(() => store.getters['event/childEventDetail']);
const isShowCustomer = computed(() => store.getters['event/isShowCustomer']);
const isShowCurrency = computed(() => store.getters['event/isShowCurrency']);
const hasShopRole = computed(() => store.getters['auth/hasShopRole']);
const hasCustomersRole = computed(() => store.getters['auth/hasCustomersRole']);
const isClientChild = computed(() => store.getters['auth/isClientChild']);
const isUseCpmParentEvent = computed(() => store.getters['event/isUseCpmParentEvent']);
const isCommonAllEvent = computed(() => store.getters['event/isCommonAllEvent']);
const isOnlyChildEvent = computed(() => store.getters['event/isOnlyChildEvent']);
const isUsePointFlagChildEvent = computed(() => store.getters['event/isUsePointFlagChildEvent']);
const isUsePointFlagParentEvent = computed(() => store.getters['event/isUsePointFlagParentEvent']);
const hasUsersRole = computed(() => store.getters['auth/hasUsersRole']);
const hasEventsRole = computed(() => store.getters['auth/hasEventsRole']);
const isShowMenuCoupon = computed(() => store.getters['event/isShowMenuCoupon']);
const canUsePointFlag = computed(() => store.getters['event/canUsePointFlag']);
const isGmoOrOfficeUrl = computed(() => store.getters['common/isGmoOrOfficeUrl']);
const isGmoOrOfficeLoginStore = computed(() => store.getters['common/isGmoOrOfficeLoginStore']);
const newSubdomain = computed(() => store.getters['common/subdomain']);
const shopDetail = computed(() => store.getters['shop/shopDetail']);
const useChildEventTicketFlag = computed(() => store.getters['event/useChildEventTicketFlag']);
const useTicketFlag = computed(() => store.getters['event/useTicketFlag'] && useChildEventTicketFlag.value);
const hasCurrency = computed(() => store.getters['event/hasCurrency']);
const hasHistoryTicketCompany = computed(() => store.getters['event/hasHistoryTicketCompany']);
const isOldEvent = computed(() => store.getters['common/isOldEvent']);
const hasManageCurrencyRole = computed(() => store.getters['auth/hasManageCurrencyRole']);
const hasPointsRole = computed(() => store.getters['auth/hasPointsRole']);
const hasManageQrRole = computed(() => store.getters['auth/hasManageQrRole']);
const commonSubdomain = computed(() => store.getters['auth/commonSubdomain']);
const parentEventName = computed(() => parentEventDetail.value?.name || '親イベント名');
const isActive = computed(() => (routeName, pattern) => {
  if (route.name) {
    return route.name.includes(routeName) || route.name.includes(pattern);
  }
  return false;
});
const accountName = computed(() => {
  const nameSei = infor.value.nameSei || '';
  const nameMei = infor.value.nameMei || '';
  return isGmoOrOfficeLoginStore.value ? shopDetail.value?.name : `${nameSei} ${nameMei}`;
});
const nameRole = computed(() => {
  if (isGmoOrOfficeLoginStore.value) return '表示中の店舗名';
  if (permission.isStore()) return 'Shop';
  if (permission.isGmo()) return 'Master';
  if (permission.isOffice()) return 'Client';
  if (permission.isGroup()) return 'Group';
  return '';
});
const nameAdmin = computed(() => {
  const role = permission.isGmo() ? 'MASTER' : 'CLIENT';
  return `${role}にてログイン中`;
});
const isRouteWithSubdomain = computed(() => {
  return (
    route.params.subdomain &&
    route.name &&
    !route.name.startsWith('Setting') &&
    route.name !== 'EventList' &&
    !route.name.includes('Notification') &&
    !route.name.includes('404') &&
    !route.name.includes('AccountCompany') &&
    !route.name.includes('AccountUser') &&
    !route.name.includes('AccountUserCpm') &&
    !route.name.includes('AccountUserLog') &&
    !route.name.includes('AccountUserCpmRegister') &&
    !route.name.includes('AccountUserCpmEdit')
  );
});
const isRouteWithDirectory = computed(() => {
  return route.params.directory && route.name && !route.name.includes('SettingEventChild');
});
const headerLogo = computed(() => {
  return isRouteWithDirectory.value && childEventDetail.value.logo?.url
    ? childEventDetail.value.logo.url
    : logoSrc.value;
});
const isShowMenuCPM = computed(() => {
  return isUseCpmParentEvent.value && !permission.isGmoOrOffice();
});
const cpmHref = computed(() => {
  return `${infor.value?.cpmUrl}/management?callback=${getEncodedRefreshToken()}`;
});
const parentQuestionUrl = computed(() => parentEventDetail.value?.urlFaq || defaultQuestionHref);
const childQuestionUrl = computed(() =>
  childEventDetail.value?.urlFaq || parentEventDetail.value?.urlFaq || defaultQuestionHref
);
const shopOrGroupEventParentNav = computed(() => {
  return [
    { routeName: 'ShopSettingInfo', icon: 'aikon-shop', content: '店舗設定', pattern: 'ShopSetting' },
    { routeName: 'ShopUser', icon: 'aikon-user', content: '顧客管理', customerFlag: true, groupFlag: true, policy: 'CUSTOMERS' },
    { routeName: 'ShopGalleryCategory', icon: 'aikon-image', content: 'ギャラリー', pattern: 'ShopGallery', policy: 'GALLERY' },
    { routeName: 'ShopMenuCategory', icon: 'aikon-menu', content: 'メニュー', pattern: 'ShopMenu', policy: 'MENU' },
    { routeName: 'ShopCoupon', icon: 'aikon-coupon', content: 'クーポン', groupFlag: true, policy: 'COUPON' },
    { routeName: 'ShopParentPointHistory', icon: 'aikon-point', content: 'ポイント履歴', groupFlag: true, typePoint: 1 },
    { icon: 'aikon-squares', content: 'CPMカード払い', cpmFlag: true },
    { routeName: 'ShopQr', icon: 'aikon-squares', content: 'QRコード', groupFlag: true },
    { href: parentQuestionUrl.value, icon: 'aikon-help', content: 'マニュアル', groupFlag: true },
  ]
});
const shopOrGroupEventChildNav = computed(() => {
  return [
    { routeName: 'ShopEventDashboardChild', icon: 'aikon-squares', content: 'ダッシュボード' },
    { routeName: 'ShopChildPointHistory', icon: 'aikon-point', content: 'ポイント履歴', typePoint: 2 },
    { routeName: 'ShopHistory', icon: 'aikon-history', content: '支払履歴', policy: 'TRANSACTIONS' },
    { routeName: 'ShopSummary', icon: 'aikon-chart_bar', content: '集計', 'policy': 'AGGREGATES' },
    { routeName: 'ShopNews', icon: 'aikon-news', content: 'お知らせ', policy: 'NEWS' },
    { href: childQuestionUrl.value, icon: 'aikon-help', content: 'マニュアル' },
  ];
});
const backBtnName = computed(() => (permission.isGmo() ? 'MASTER' : 'CLIENT') + 'に戻る');
const appUrl = computed(() => infor.value?.appUrl || parentEventDetail.value?.appUrl || '');
const adminUrl = computed(() => `${appUrl.value}event/${newSubdomain.value}/shop`);
const isGmoOrOfficeLoginStoreUseCpm = computed(() => isGmoOrOfficeLoginStore.value && isUseCpmParentEvent.value && !!parentEventDetail.value.hasJoinEventCpm);
const isCpmMenuShown = computed(() => permission.isStoreOrOffice() && !isGmoOrOfficeLoginStore.value);
const questionUrl = computed(() => !route.params?.directory ? parentQuestionUrl.value : childQuestionUrl.value)
const masterOrClientMenu = computed(() => {
  const settingRouteName = !hasUsersRole.value ? 'SettingEvent' : 'SettingUser';
  const hiddenRouteNames = ['EventList', 'Notification', 'AccountUser', 'AccountCompany', 'NotificationRegister'];
  const isIconQuestionNotShown = (route.name?.includes('SettingUser') ||
    route.name?.includes('SettingEvent') ||
    hiddenRouteNames.includes(route.name)) &&
    permission.isGmoOrOffice();
  let data = [
    { href: questionUrl.value, icon: 'aikon-question' },
    { routeName: settingRouteName, icon: 'aikon-gear', pattern: 'Setting' },
    { routeName: 'Notification', icon: 'aikon-speaker' },
  ];
  if (permission.isGmo() || isIconQuestionNotShown) {
    data = data.filter(e => !e?.href);
  }
  return data;
});
const masterOrClientEventChildNav = computed(() => {
  const currencyRouteName = (!hasCustomersRole.value && !permission.isGmo()) ||
    !hasManageCurrencyRole.value ? 'EventCurrencyQr' : 'EventCurrency';
  return [
    { routeName: 'EventDashboardChild', icon: 'aikon-dashboard', content: 'ダッシュボード' },
    { routeName: 'EventStoreAttendList', icon: 'aikon-shop', content: '参加店舗リスト', policy: 'SHOPS', pattern: 'EventStoreAttend' },
    { routeName: currencyRouteName, icon: 'aikon-creditcard_fill', content: '通貨管理', policy: 'CURRENCY', currencyFlag: true, pattern: 'EventCurrency' },
    { routeName: 'EventChildPointHistory', icon: 'aikon-point', content: 'ポイント', typePoint: 2, pattern: 'EventChildPoint'},
    { routeName: 'EventHistoryBuy', icon: 'aikon-history', content: '履歴', pattern: 'EventHistory', policy: 'TRANSACTION', historyFlag: true },
    { routeName: 'EventSummary', icon: 'aikon-chart_bar', content: '集計', policy: 'AGGREGATE' },
    { routeName: 'News', icon: 'aikon-news', content: 'お知らせ' },
  ]
});

const handleRedirect = async () => {
  if (localStorage.getItem('refreshToken')) {
    window.location.href = `${adminUrl.value}?callback=${getEncodedRefreshToken()}`;
  } else {
    window.location.href = `${adminUrl.value}`;
  }
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('token');
  store.commit('common/SET_IS_OLD_EVENT', null);
};
const handleTabCPM = async () => {
  const newTab = window.open('about:blank', '_blank');
  await store.dispatch('event/getParentEventDetail', commonSubdomain.value);
  if (!parentEventDetail.value?.hasJoinEventCpm) {
    if (newTab) newTab.close();
    router.push({ name: '404' });
    return;
  }
  if (newTab) newTab.location.href = cpmHref.value;
  store.commit('auth/RESET_LOCAL_STORAGE');
  router.push({ name: 'Login' }).then(() => message.showError('outOfLoginSession')).catch(() => {});
};
const logout = async () => {
  if (isGmoOrOfficeLoginStore.value && !isOldEvent.value) {
    window.location.href = `${appUrl.value}login`;
  }
  await store.dispatch('auth/logout');
  instance.parent.transitionName = '';
};
const checkPolicy = (policy, shopFlag = null) => {
  if (policy && RoleConstants.ROLE_SHOPS_OFFICE.toUpperCase() === policy && shopFlag && isClientChild.value) {
    return false;
  }
  if (policy && infor.value?.kind === RoleConstants.ROLE_OFFICE) {
    const validPolicy = (isGmoOrOfficeLoginStore.value && policy === 'COUPON') || ['TRANSACTION', 'AGGREGATE'].includes(policy);
    const newPolicy = validPolicy ? `${policy}S` : policy;
    if (isGmoOrOfficeLoginStore.value && ['NEWS', 'GALLERY', 'MENU'].includes(policy)) return true;
    return infor.value?.role?.includes(RoleConstants['ROLE_' + newPolicy + '_OFFICE']) &&
      (newPolicy === 'COUPONS' ? hasShopRole.value : true);
  }
  if (policy && RoleConstants.ROLE_STORE_OR_GROUP.includes(infor.value?.kind) && parentEventDetail.value?.shopMenus) {
    if (['TRANSACTIONS', 'AGGREGATES', 'CUSTOMERS'].includes(policy)) return true;
    return parentEventDetail.value?.shopMenus[policy.toLowerCase()] && (policy !== 'COUPON' || isShowMenuCoupon.value);
  }
  return true;
};
const checkEventSummary = (policy) => {
  const isClientChildNoShopRole = isClientChild.value && !infor.value?.role?.includes(RoleConstants.ROLE_SHOPS_OFFICE);
  const isClientNoShopRole = permission.isOffice() && !infor.value?.role?.includes(RoleConstants.ROLE_SHOPS_OFFICE);
  return !(policy === RoleConstants.ROLE_AGGREGATES_OFFICE.toUpperCase() &&
    (isClientChildNoShopRole || (isClientNoShopRole && !isShowCurrency.value))
  );
};
const checkCurrencyFlag = (currencyFlag) => {
  const isClientUseTicketFlag = (hasCustomersRole.value && (hasManageQrRole.value || hasManageCurrencyRole.value)) ||
    (hasManageQrRole.value && !permission.isGmo());
  return !currencyFlag || (currencyFlag && isShowCurrency.value && isClientUseTicketFlag);
};
const checkHistoryFlag = (historyFlag) => {
  return !historyFlag || !(historyFlag && useTicketFlag.value && !hasCurrency.value && !hasHistoryTicketCompany.value && isClientChild.value);
};
const checkDisabledIcon = (pattern) => pattern === 'Setting' && !hasEventsRole.value && !hasUsersRole.value;
const checkTypePoint = (typePoint) => {
  const isParentPointMenu = (typePoint === StatusConstants.pointType.all.value) &&
    isCommonAllEvent.value && !isClientChild.value &&
    isUsePointFlagParentEvent.value && canUsePointFlag.value &&
    (hasPointsRole.value || permission.isStoreOrGroup());
  const isChildPointMenu = (typePoint === StatusConstants.pointType.special.value) &&
    isOnlyChildEvent.value && isUsePointFlagChildEvent.value &&
    canUsePointFlag.value && (hasPointsRole.value || permission.isStoreOrGroup());
  return !typePoint || isParentPointMenu || isChildPointMenu;
};
const checkCustomerFlag = (customerFlag) => !customerFlag || (customerFlag && isShowCustomer.value);
const checkCpmFlag = (cpmFlag) => {
  return !cpmFlag || (cpmFlag && isShowMenuCPM.value && parentEventDetail.value?.hasJoinEventCpm);
}
const checkGroupFlag = (groupFlag) => (permission.isGroup() ? groupFlag : true);
</script>

<style scoped>
.custom-side-btn {
  font-size: 0.75rem !important;
}
</style>
